import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { authMe, authLogin, authRegister, authLogout, authSession } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [showAuth, setShowAuth] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  useEffect(() => {
    if (process.env.REACT_APP_DESIGN_PREVIEW === "true") { setUser(false); return; }
    // If returning from the Emergent Google OAuth callback, exchange the session_id first.
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.slice(1)).get("session_id");
      authSession(sid)
        .then((u) => setUser(u))
        .catch(() => setUser(false))
        .finally(() => {
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
        });
      return;
    }
    authMe().then(setUser).catch(() => setUser(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const u = await authLogin({ email, password });
    setUser(u);
    return u;
  };
  const register = async (name, email, password) => {
    // Registration acknowledges an email challenge; it is not a logged-in user.
    return authRegister({ name, email, password });
  };
  const logout = async () => {
    await authLogout();
    setUser(false);
  };
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const loginWithGoogle = () => {
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const openAuth = useCallback((mode = "login") => {
    if (process.env.REACT_APP_DESIGN_PREVIEW === "true") { toast.info("Contact help@lenisnutrition.co.uk for account assistance."); return; }
    setAuthMode(mode);
    setShowAuth(true);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loginWithGoogle, showAuth, setShowAuth, authMode, setAuthMode, openAuth }}>
      {children}
    </AuthContext.Provider>
  );
}


